import { Component } from '@angular/core';

import { ContentPageService } from './page.service';

@Component({
    standalone: false,
    selector: 'wl-content-page',
    template: `
        <ng-container *ngIf="page$ | async as page">
            <abs-page-layout [pageTitle]="page.name | language | async">
                <div class="content">
                    <abs-admin-panel label="Edit Page">
                        <div class="admin-panel-actions">
                            <a class="admin-panel-btn" [routerLink]="['/admin/games/global/entity/pages', page._id]">
                                Edit this page in admin
                            </a>
                        </div>
                    </abs-admin-panel>
                    <div [innerHTML]="page.content | language | async"></div>
                </div>
            </abs-page-layout>
        </ng-container>
    `
})
export class ContentPageComponent {
    page$ = this.pageService.page$;
    constructor(public pageService: ContentPageService) {}
}
